import React from 'react';
import {TooltipRenderProps} from 'react-joyride';

import {Transition} from '@headlessui/react';
import {Fragment} from 'react';
import Button from './Tailwind/Button';
import classNames from 'classnames';
import Book from 'Icons/Book';
import Discord from 'Icons/Discord';
import {useProductContext} from 'Contexts/ProductContext';

export const TooltipContentText: React.FC<React.PropsWithChildren<{className?: string}>> = ({children, className}) => (
    <p className={classNames('text-sm text-neutral-300', className)}>{children}</p>
);

export const TooltipContentSubHeader: React.FC<React.PropsWithChildren<{className?: string}>> = ({
    children,
    className,
}) => <h2 className={classNames('text-md font-semibold', className)}>{children}</h2>;

export const TooltipContent: React.FC<React.PropsWithChildren<{className?: string}>> = ({children, className}) => (
    <div className={classNames('text-sm text-neutral-300', className)}>{children}</div>
);

export const JoyRideTooltip: React.FC<TooltipRenderProps> = ({
    backProps,
    skipProps,
    continuous,
    index,
    isLastStep,
    primaryProps,
    step,
    size,
    tooltipProps,
}) => {
    const isOpen = !!step;
    const {mode} = useProductContext();

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
            >
                <div
                    className="w-full min-w-[600px] max-w-2xl transform overflow-hidden rounded-2xl bg-neutral-700 p-6 text-left align-middle shadow-xl transition-all"
                    {...tooltipProps}
                >
                    <div className="mb-2 flex w-full flex-row justify-between py-2">
                        <h3 className="text-2xl font-bold leading-6 text-sky-400">{step.title}</h3>
                        <h3 className="text-lg font-medium leading-6 text-neutral-100">
                            {index + 1}/{size}
                        </h3>
                    </div>
                    <div className="mt-2 flex flex-col gap-3">
                        {Array.isArray(step.content) ? (
                            step.content.map((contentToRender) => contentToRender)
                        ) : (
                            <TooltipContentText>{step.content}</TooltipContentText>
                        )}
                    </div>
                    <footer className="mt-12 flex w-full flex-col gap-2"></footer>
                    <div className="mt-8 flex flex-row flex-nowrap justify-between gap-2">
                        <div className="flex gap-2">
                            <Button error outlined {...skipProps}>
                                Skip
                            </Button>
                            <Button
                                onClick={() =>
                                    window.location.assign(
                                        mode === 'Rendition_Code'
                                            ? 'https://discord.gg/tcdfvq4vzG'
                                            : 'https://discord.gg/hkV7apRz'
                                    )
                                }
                                outlined
                                className="basis-auto"
                            >
                                <Discord size={16} className="mr-1" /> Get Help
                            </Button>
                            <Button outlined disabled className="basis-auto cursor-not-allowed">
                                <Book size={12} className="mr-2" /> Docs
                            </Button>
                        </div>
                        <div className="flex flex-row gap-2">
                            {index !== 0 && (
                                <Button outlined {...backProps}>
                                    Back
                                </Button>
                            )}
                            <Button outlined {...primaryProps}>
                                {isLastStep ? 'Done' : 'Continue'}
                            </Button>
                        </div>
                    </div>
                </div>
            </Transition.Child>
        </Transition>
    );
};
